export enum FilterType {
  Sort = "sort",
  Stops = "stops",
  Times = "times",
  Price = "price",
  Fare = "fare",
  Airline = "airline",
}

// Additional accordion IDs used only in the mobile filter modal
export enum ModalAccordionId {
  OutboundArrival = "outboundArrival",
  ReturnArrival = "returnArrival",
  Airport = "airport",
  FlightNumber = "flightNumber",
}

export interface HorizontalFilterBarProps {
  handleOpenFilters: (filterType?: FilterType) => void;
}

export interface FilterChipData {
  key: FilterType;
  label: string;
  isActive: boolean;
}
